import React, { useState } from 'react'
import { filterResponsive, pageTitle, rightResponsive } from '../../../common/cssclasses'
import { useTranslate } from '../../../components/TranslationText'
import SemenFilter from '../Components/SemenFilter';
import SemenCard from '../Components/SemenCard';
import { GuidGenerator } from '../../../helper/GuidGenerator';

export default function SemenMarketListPage() {
    const { translate } = useTranslate();
    const [activeTab, setActiveTab] = useState('Wathba Stallions');

    const dummyData = [
        {
            coverImage: 'https://admin.eahs.ae/Shared/ImagesUploads/dcdb9cf3-eaa6-41c1-9f44-27ee2c7e16e2.jpeg',
            horseName: 'Larando',
            regNumber: '123456',
            price: 500,
            birthDate: new Date(),
            ownerName: 'Wathba Stallions',
            address: 'Dubai, UAE',
            origin: 'UAE',
            sire: 'Sire Name',
            dam: 'Dam Name',
            color: 'White',
            isVip: true,
            horseId: GuidGenerator(),
            horseCategory: 'Show Horse',
        },
        {
            coverImage: 'https://admin.eahs.ae/Shared/ImagesUploads/e5fd2494-6858-45ee-9e68-978d4ea45970.jpeg',
            horseName: 'Rami',
            regNumber: '654',
            price: 500,
            birthDate: new Date(),
            ownerName: 'Wathba Stallions',
            address: 'Dubai, UAE',
            origin: 'UAE',
            sire: 'Sire Name',
            dam: 'Dam Name',
            color: 'White',
            isVip: true,
            horseId: GuidGenerator(),
            horseCategory: 'Show Horse',
        },
    ]


    const [horses, setHorses] = useState(dummyData);
    const uniqueCategories = [...Array.from(new Set(horses.map(horse => horse.ownerName)))];


    return (
        <div className="row  rtl">
            <h2 className={pageTitle}>
                {translate('web.semenMarket', 'Semen Market')}
            </h2>
            <div className={filterResponsive}>
                <SemenFilter key={'Semen Filter'} />
            </div>
            <div className={rightResponsive}>
                <div className="row  second_section_bar " style={{  justifyContent: 'flex-start' }}>
                    {uniqueCategories.map((item, index) => (
                        <>
                            <div
                                className={"col-lg-2 col-md-4 col-sm-6 col-8 my-2 text-center px-0"} style={{ minWidth: 250 , cursor:'pointer'}}
                                onClick={() => setActiveTab(item)}
                            >

                                <span className={`${activeTab == item ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 14 }}>{item}</span>

                                <div className="service_bar_underline" style={activeTab == item ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
                            </div>
                        </>
                    ))}
                </div>
                <div className='row'>
                    {horses.map((item) => (
                        <SemenCard key={'SemenCard'} horse={item} />
                    ))}
                </div>
            </div>
        </div>
    )
}
